import { render, staticRenderFns } from "./nursePresAddAj.vue?vue&type=template&id=76e478c1&scoped=true&"
import script from "./nursePresAddAj.vue?vue&type=script&lang=ts&"
export * from "./nursePresAddAj.vue?vue&type=script&lang=ts&"
import style0 from "./nursePresAddAj.vue?vue&type=style&index=0&id=76e478c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e478c1",
  null
  
)

export default component.exports